import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import './nominations-page.css';
import { Loading } from '../../common/Loading/Loading';
import RequestFormPage from './RequestFormPage';
import NominationsPage from './NominationsPage';

function NewRequestPage(props) {
    const { categories } = props;
    return (
        <>
            {categories ? (
                <Routes>
                    <Route path={':nominationId'} element={<RequestFormPage />} />
                    <Route path="" element={<NominationsPage categories={categories} />} />
                </Routes>
            ) : (
                <div className="position-relative mt-5">
                    <Loading text="Ожидание данных..." />
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    const {
        categories: { categories }
    } = state;
    return { categories };
}

export default connect(mapStateToProps)(NewRequestPage);
